export default __webpack_public_path__ + "static/media/330_business06-fr-mobile.7563a27e.png";